import * as constants from 'appConstants';

export const wsAttachment = (payload) => ({
  type: constants.WS_ATTACHMENT,
  payload
});
